/**
 * Labstep
 *
 * @module components/ExperimentValue/List/Lineage
 * @desc Lineage Parents List
 */

import { ProtocolValueListLineageChildrenContainer as ProtocolValueListLineageChildren } from 'labstep-web/components/ProtocolValue/List/Lineage/Children';
import { ProtocolValueListLineageParentsContainer as ProtocolValueListLineageParents } from 'labstep-web/components/ProtocolValue/List/Lineage/Parents';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { ProtocolValueListLineageProps } from './types';

export const ProtocolValueListLineage: React.FC<
  ProtocolValueListLineageProps
> = ({ resourceItem }) => {
  const hasChildren =
    resourceItem.input_experiment_ids &&
    resourceItem.input_experiment_ids.length > 0;

  const hasParents =
    resourceItem.protocol_value_origin &&
    resourceItem.protocol_value_origin.is_lineage;

  if (!hasParents && !hasChildren) {
    return (
      <CardEmptyState
        src="/img/empty-state/inventory.svg"
        title="No lineage"
        explanation={
          <p>
            Use ‘Inventory’ elements in your Protocols and Experiments
            to keep track of how items were created and trace the
            lineage back to other items in your inventory. For more on
            lineage tracking see{' '}
            <a
              href="https://help.labstep.com/en/"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>
            .
          </p>
        }
      />
    );
  }

  return (
    <div>
      <ProtocolValueListLineageParents resourceItem={resourceItem} />
      <ProtocolValueListLineageChildren resourceItem={resourceItem} />
    </div>
  );
};
